export default __webpack_public_path__ + "static/media/Snd_e4.67bdbe70.mp3";